import { getLegacyDomain } from '@paytrace/pt-skel/Helper'

export function viewReceipt (merchantId: string, id: string) {
  window.open(`${getLegacyDomain()}/receipt.pay?tranxid=${id}&id=${merchantId}`, '_blank')
}
